import { OrderProduct } from '@zonofi/zono-money-store';
import React, { useMemo } from 'react';
import { ReactComponent as ArrowIconDown } from '@zonofi/svg-icons/arrow_down.svg';

interface UomSelectorProps {
  quantity: number;
  openUomModal?: () => void;
  product: OrderProduct;
  /** When true, PCS / UOM row is non-interactive (e.g. out of stock). */
  disabled?: boolean;
}

export const UomSelector: React.FC<UomSelectorProps> = ({
  openUomModal,
  quantity,
  product,
  disabled = false,
}) => {
  const displayValue = useMemo(() => {
    const { additionalUOM, baseUOM, packSize } = product;
    if (!additionalUOM) return baseUOM || 'PCS';
    if (quantity < packSize) return baseUOM || 'PCS';
    return `${Math.ceil(quantity / packSize)} ${additionalUOM}`;
  }, [product]);

  return (
    <div
      onClick={() => {
        if (disabled) return;
        product.additionalUOM && openUomModal?.();
      }}
      className={`product-uom-dropdown ${disabled ? 'product-uom-dropdown--disabled' : ''}`}
      style={disabled ? { pointerEvents: 'none', opacity: 0.6 } : undefined}
    >
      <span className="product-uom-dropdown-content font-regular">
        {displayValue}
      </span>
      {product.additionalUOM && (
        <span className="product-uom-dropdown-icon">
          <ArrowIconDown />
        </span>
      )}
    </div>
  );
};
